import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["businessTypeRadio", "createSiteBtn", "serviceField"]

  connect() {
    this.validateReviewStep()
    if (this.hasBusinessTypeRadioTarget) {
      this.businessTypeRadioTargets.forEach(radio => {
        radio.addEventListener("change", () => this.validateReviewStep())
      })
    }
  }

  validateReviewStep() {
    const selected = this.hasBusinessTypeRadioTarget ? this.businessTypeRadioTargets.some(radio => radio.checked) : true
    if (this.hasCreateSiteBtnTarget) {
      this.createSiteBtnTarget.disabled = !selected
    }
  }

  // If services can be edited in review, sync hidden fields
  syncServiceFields() {
    // Collect all service values and update hidden fields
    const services = this.serviceFieldTargets.map(input => input.value.trim()).filter(v => v.length > 0)
    const hiddenFieldsDiv = document.getElementById("review-services-hidden-fields")
    if (hiddenFieldsDiv) {
      hiddenFieldsDiv.innerHTML = ""
      services.forEach(service => {
        const input = document.createElement("input")
        input.type = "hidden"
        input.name = "wizard_data[services][]"
        input.value = service
        hiddenFieldsDiv.appendChild(input)
      })
    }
  }
}
